/** The HTTP statuses the ordering host answers with that a page branches on. */
const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  NOT_FOUND: 404,
  CONFLICT: 409,
  GONE: 410,
  TOO_MANY_REQUESTS: 429
} as const

export { HTTP_STATUS }
